import { PageBackground } from '@backrs_ui/grow-ui/src/appRoutes.constants';

import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

type SxCallback = (theme: Theme) => SystemStyleObject<Theme>;

const defaultSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Beige/25'],
});

const beigeSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Beige/50'],
});

const brandSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Brand/25'],
});

const brandDotsSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Brand/25'],
  backgroundImage: `radial-gradient(circle, ${backrs.colors['Gray/300']}33 2px, transparent 1px)`,
  backgroundSize: '28px 28px',
});

const brandGridSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Brand/25'],
  backgroundImage: `linear-gradient(${backrs.colors['Brand/500']}33 1px, transparent 1px),
                    linear-gradient(90deg, ${backrs.colors['Brand/500']}33 1px, transparent 1px)`,
  backgroundSize: '28px 28px',
});

const whiteSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
});

const whiteGridSx: SxCallback = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
  backgroundImage: `linear-gradient(${backrs.colors['Brand/500']}33 1px, transparent 1px),
                    linear-gradient(90deg, ${backrs.colors['Brand/500']}33 1px, transparent 1px)`,
  backgroundSize: '28px 28px',
});

const PAGE_BACKGROUNDS: Record<PageBackground, SxCallback> = {
  default: defaultSx,
  beige: beigeSx,
  brand: brandSx,
  'brand-dots': brandDotsSx,
  'brand-grid': brandGridSx,
  white: whiteSx,
  'white-grid': whiteGridSx,
};

export const resolvePageBackground = (background: PageBackground): SxCallback =>
  PAGE_BACKGROUNDS[background] ?? PAGE_BACKGROUNDS.default;
